import React from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import * as actions from "redux/actions/commentActions";
import { Translate } from "react-redux-i18n";
import { EllipsisH } from "theme/icon";
import CloseModal from './CloseModal';
import RollModal from './RollModal';
import OptionAlertModal from './OptionAlertModal';
import { openOptionAnalysis } from 'utils/portfolioNav';

const ActionBtnRight = (props) => {
    const [open, setOpen] = React.useState(false);
    const [close, setClose] = React.useState(false);
    const [roll, setRoll] = React.useState(false);
    const [alertOpen, setAlertOpen] = React.useState(false);
    const rootRef = React.useRef(null);

    React.useEffect(() => {
        const handleOutsideClick = (event) => {
            if (rootRef.current && !rootRef.current.contains(event.target)) {
                setOpen(false);
            }
        };

        document.addEventListener('mousedown', handleOutsideClick);
        return () => document.removeEventListener('mousedown', handleOutsideClick);
    }, []);

    const handleToggleMenu = (event) => {
        event.stopPropagation();
        setOpen((prev) => !prev);
    };

    const onClickRoll = (event) => {
        event.stopPropagation();
        setOpen(false);
        setRoll(true);
    };

    const onClickClose = (event) => {
        event.stopPropagation();
        setOpen(false);
        setClose(true);
    };

    const onClickAlert = (event) => {
        event.stopPropagation();
        setOpen(false);
        setAlertOpen(true);
    };

    const onClickAnalysis = (event) => {
        event.stopPropagation();
        setOpen(false);
        if (props.item?.id != null) {
            openOptionAnalysis(props.item.id);
        }
    };

    const onClickDelete = (event) => {
        event.stopPropagation();
        setOpen(false);
        props.delete();
    };

    return (
        <div ref={rootRef} style={{ position: 'relative', display: 'inline-block' }}>
            <span
                className="icon-button"
                style={{
                    padding: '3px',
                    background: 'gray',
                    borderRadius: '50%',
                }}
                onClick={handleToggleMenu}
                role="button"
                tabIndex={0}
                aria-haspopup="true"
                aria-expanded={open}
                onKeyDown={(event) => {
                    if (event.key === 'Enter' || event.key === ' ') {
                        event.preventDefault();
                        handleToggleMenu(event);
                    }
                }}
            >
                <EllipsisH />
            </span>
            {open && (
                <ul
                    className="list portfolio-action-menu"
                    style={{
                        background: '#1b3745',
                        position: 'absolute',
                        right: 0,
                        top: '100%',
                        zIndex: 100,
                        margin: 0,
                        padding: 0,
                        listStyle: 'none',
                        minWidth: 120,
                    }}
                >
                    <li
                        className="list-item"
                        onClick={onClickClose}
                        style={{ width: '100%', paddingInline: '8px', cursor: 'pointer' }}
                    >
                        <Translate value="close" />
                    </li>
                    <li
                        className="list-item"
                        onClick={onClickRoll}
                        style={{ width: '100%', paddingInline: '8px', cursor: 'pointer' }}
                    >
                        Roll
                    </li>
                    <li
                        className="list-item"
                        onClick={onClickAlert}
                        style={{ width: '100%', paddingInline: '8px', cursor: 'pointer' }}
                    >
                        <Translate value="option_menu_alert" />
                    </li>
                    <li
                        className="list-item"
                        onClick={onClickAnalysis}
                        style={{ width: '100%', paddingInline: '8px', cursor: 'pointer' }}
                    >
                        <Translate value="option_menu_analysis" />
                    </li>
                    <li
                        className="list-item"
                        onClick={onClickDelete}
                        style={{ width: '100%', paddingInline: '8px', cursor: 'pointer' }}
                    >
                        <Translate value="delete" />
                    </li>
                </ul>
            )}
            {close && (
                <CloseModal
                    item={props.item}
                    key={props.key}
                    price={props.price}
                    close={() => setClose(false)}
                />
            )}
            {roll && (
                <RollModal
                    item={props.item}
                    key={props.key}
                    price={props.price}
                    close={() => setRoll(false)}
                />
            )}
            <OptionAlertModal
                item={props.item}
                open={alertOpen}
                onClose={() => setAlertOpen(false)}
            />
        </div>
    );
};

ActionBtnRight.propTypes = {
    item: PropTypes.object,
    price: PropTypes.any,
    delete: PropTypes.func,
};

function mapStateToProps(reducer) {
    return {
        user_id: reducer.session.auth.id,
        token: reducer.session.auth.token,
        user: reducer.session.auth,
    };
}

const mapDispatchToProps = dispatch => ({
    removeItem: (params, token) =>
        dispatch(actions.removeItem({ params, token })),
    reportItem: (params, token) =>
        dispatch(actions.reportItem({ params, token })),
});

export default connect(mapStateToProps, mapDispatchToProps)(ActionBtnRight);
